import * as React from 'react';
import get from 'lodash.get';
import InputMask from 'react-input-mask';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  AbsoluteBox,
  InputField,
  color,
  SvgIconButton,
  Grid,
  SvgIcon
} from '@kis-technologies/kis-ui';
import { NumPadAction } from 'components/NumPad';
import { useKeyboard } from 'hooks/useKeyboard';
import { selectors as configSelectors } from 'services/configuration';
import { ComponentProps } from '../types';
import { useStyles } from '../styled';

export const BarcodeKeyEntry = (props: ComponentProps) => {
  const { t, i18n } = useTranslation();
  const { onCancel, onSubmit, value: preValue } = props;
  const configuration = useSelector(configSelectors.selectConfiguration);

  const messages = get(configuration, 'cityPass.ticketEntry.manualEntry.messages');
  const lookupHeader = get(messages, `header.${i18n.language}`) || t('cityPass.lookupCityPass');
  const lookupSubheader = get(messages, `subheader.${i18n.language}`) || t('cityPass.lookupDescription');
  const lookupPlaceHolder = get(messages, `placeholder.${i18n.language}`) || t('cityPass.lookupPlaceHolder');
  const [value, setValue] = useKeyboard(preValue);

  const handleNumpadClick = (_: React.MouseEvent<HTMLButtonElement>, v: string) => setValue(v);
  const classes = useStyles({})();
  return (
    <>
      <Grid className={classes.lookupSearchContainer}>
        <Grid className={classes.lookupSearchInnerContainer}>
          <div className={classes.ticketSearchInput}>
            <Box flexOverride="none" margin="6">
              <Typography fontSize={72} fontWeight={800} align="center">
                {lookupHeader}
              </Typography>
            </Box>
            <Typography className={classes.ticketSearchSubHeading}>{lookupSubheader}</Typography>
            <div className={classes.ticketNumInputBox}>
              <InputMask mask="9999 9999 9999 9999 999" name="cityPassInput" value={value} maskPlaceholder={null}>
                <InputField
                  autoFocus
                  size="large"
                  align="center"
                  placeholder={lookupPlaceHolder}
                  fullWidth
                  sx={{ borderColor: value.length >= 19 ? color.GREEN : color.LIGHT_GRAY }}
                  endIcon={
                    <SvgIconButton
                      iconColor={color.GREEN}
                      sx={{ opacity: value.length >= 19 ? 1 : 0 }}
                      appearance="transparent"
                      data-testid={'checked-icon-button'}
                    >
                      <SvgIcon name="checked" size={40} />
                    </SvgIconButton>
                  }
                />
              </InputMask>
            </div>
          </div>
          <AbsoluteBox raised fullWidth bg="x-light-gray" bottom="0" left="0">
            <Grid>
              <NumPadAction
                onClick={handleNumpadClick}
                onConfirm={() => onSubmit(value)}
                onBack={onCancel}
                isConfirmDisabled={value.length < 19}
                confirmConfig={{
                  label: t('commonText.next'),
                  backLabel: t('commonText.back'),
                  customSize: 'x-large',
                  width: 475,
                  appearance: 'primary'
                }}
              />
            </Grid>
          </AbsoluteBox>
        </Grid>
      </Grid>
    </>
  );
};
